import React from 'react';
import AppHeader, { RelojEncabezado, ChipRol } from 'components/ui/AppHeader';
import AppHeaderBase from 'components/ui/AppHeaderBase';
import { useAuth } from 'contexts/AuthContext';
import { seccionesParaRol } from 'components/navItems';

// Encabezado de toda pantalla de la app: el común de VLS (AppHeader, copia de
// shared/vls-ui), que generaliza el de fincas que esta app ya usaba. Mismo menú
// por rol (navItems.js), el reloj común de shared (RelojEncabezado, 24 h) a la
// derecha y el logo oficial del kit (/vls-logo.png, el que pone AppHeader).
// El logo lleva siempre al hub de VLS (https://vlscr.net), con PIN, kiosco y
// SSO (criterio único de pantallas móviles y kioscos, shared/vls-ui/README.md).
//   PIN: sin menú; el logo pide confirmación antes de salir (teléfono compartido)
//        y "Salir" (onSalir) cierra el turno del inspector en ese teléfono
//        (signOut local de la cuenta técnica, no el SSO).
//   Pantalla del PIN (sin sesión): EncabezadoIngresoPin, sin menú ni Salir y con
//        la misma confirmación en el logo.
//   Kiosco: menú de su rol, confirmación en el logo y sin Salir (la cuenta
//        kiosco comparte la sesión de .vlscr.net: un signOut sacaría a todas).
//   SSO: menú de su rol, el logo va directo al hub y, después del reloj, el chip
//        de rol común (ChipRol: Administrador / Editor / Lectura): por SSO entran
//        tres roles, así que el chip dice algo (regla 3 de la derecha). El PIN y
//        el kiosco son una sola cuenta cada uno: sin chip. La sesión SSO es
//        personal: lleva las iniciales de quien entró y "Salir" normal (el
//        signOut del contexto). El onSalir que pasan las pantallas del
//        asistente es el del PIN (borra el borrador y avisa de la cola): con
//        SSO no se usa.
// hayAvance: en el asistente, true si hay una inspección sin terminar. Su
// borrador queda guardado en el equipo por el día (lib/borrador) y el mensaje
// de la confirmación lo dice.
export const NOMBRE_APP = 'Cables y cuerdas';
export const URL_HUB = 'https://vlscr.net';
export const DOMINIO_APP = 'cables.vlscr.net';

export function mensajeConfirmarHub({ esKiosco = false, hayAvance = false } = {}) {
  const equipo = esKiosco ? 'esta tablet' : 'este teléfono';
  if (hayAvance) {
    return 'Va a salir de la bitácora de cables con una inspección sin terminar y sin enviar. '
      + `Queda guardada en ${equipo} solo por hoy. Para seguirla, abra ${DOMINIO_APP}`;
  }
  return `Va a salir de la bitácora de cables de ${equipo}. Para volver, abra ${DOMINIO_APP}`;
}

export default function EncabezadoApp({ onSalir, hayAvance = false, alIrAlHub }) {
  const { role, esKiosco, esPin, signOut, userDisplayName } = useAuth();
  const compartido = !!(esPin || esKiosco);
  // Criterio único (shared/vls-ui/README.md, Pantallas móviles y kioscos):
  // PIN, el Salir que olvida el PIN; kiosco, sin Salir; SSO personal, Salir normal.
  let salir;
  if (esPin) salir = onSalir;
  else if (!esKiosco && signOut) salir = () => signOut();
  return (
    <AppHeader
      titulo={NOMBRE_APP}
      hubUrl={URL_HUB}
      confirmarHub={compartido ? mensajeConfirmarHub({ esKiosco: !esPin && !!esKiosco, hayAvance }) : undefined}
      alIrAlHub={alIrAlHub}
      secciones={seccionesParaRol(role, { esKiosco, esPin })}
      navDesde="md"
      acciones={<><RelojEncabezado />{!compartido && <ChipRol rol={role} />}</>}
      usuario={compartido ? undefined : userDisplayName}
      onSalir={salir}
    />
  );
}

// Encabezado de la pantalla de ingreso con PIN (antes de la sesión, fuera del
// router): el mismo común de VLS, sin menú y sin Salir (todavía no hay sesión).
// El logo lleva al hub con confirmación: el teléfono es compartido.
export function EncabezadoIngresoPin({ alIrAlHub } = {}) {
  return (
    <AppHeaderBase
      titulo={NOMBRE_APP}
      hubUrl={URL_HUB}
      confirmarHub={mensajeConfirmarHub()}
      alIrAlHub={alIrAlHub}
      navDesde="md"
      acciones={<RelojEncabezado />}
    />
  );
}
